<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right"></div>
    <div class="ir-line-content">
      <span>{{ 'machines.machine' | translate }} {{ machine?.serialNumber }}</span>
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="ir-content-fixed ir-mv2 th-content">
    <div class="ir-content-fixed th-content">
      <h1>
        <span *ngIf="machine?.modelName">{{ machine.modelName }}</span>
      </h1>
      <div class="ir-position--b th-home">
        <div class="ir-bloc ir-ph4 ir-pv4">
          <div class="ir-row">
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4">
              <div (click)="createInspection()" class="ir-btn ir-btn--big ir-btn--block th-btn-action">
                <span>{{ 'inspections.new-inspection' | translate }}</span>
              </div>
            </div>
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4">
              <div (click)="viewInspections()" class="ir-btn ir-btn--big ir-btn--block th-btn-action">
                <span>{{ 'inspections.inspections' | translate }}</span>
              </div>
            </div>
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4">
              <div (click)="editMachine()" class="ir-btn ir-btn--big ir-btn--block th-btn-action">
                <span>{{ 'common.edit' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
